import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import PdfPreviewModal from '../components/PdfPreviewModal';

const PdfPreviewContext = createContext(null);

// Global reference for use outside React components
let globalShowPdfPreview = null;

export const PdfPreviewProvider = ({ children }) => {
  const [previewData, setPreviewData] = useState(null);

  const showPdfPreview = useCallback((pdfBlob, filename = 'document.pdf') => {
    setPreviewData({ pdfBlob, filename });
  }, []);

  // Register global function on mount
  useEffect(() => {
    globalShowPdfPreview = showPdfPreview;
    return () => {
      globalShowPdfPreview = null;
    };
  }, [showPdfPreview]);

  const hidePdfPreview = useCallback(() => {
    setPreviewData(null);
  }, []);

  return (
    <PdfPreviewContext.Provider value={{ showPdfPreview, hidePdfPreview }}>
      {children}
      {previewData && (
        <PdfPreviewModal
          pdfBlob={previewData.pdfBlob}
          filename={previewData.filename}
          onClose={hidePdfPreview}
        />
      )}
    </PdfPreviewContext.Provider>
  );
};

export const usePdfPreview = () => {
  const context = useContext(PdfPreviewContext);
  if (!context) {
    throw new Error('usePdfPreview must be used within a PdfPreviewProvider');
  }
  return context;
};

// Global function for use outside React components (like pdfGenerator.js)
export const openPdfPreviewGlobal = (pdfBlob, filename) => {
  if (globalShowPdfPreview) {
    globalShowPdfPreview(pdfBlob, filename);
  } else {
    // Fallback: download directly if context not available
    const url = URL.createObjectURL(pdfBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};
